module.exports = __webpack_public_path__ + "static/media/newsImage9.700b9980.svg";